// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { TableCellLayout, makeStyles, tokens } from '@fluentui/react-components';
import React, { FC } from 'react';
import { injectIntl } from 'react-intl';
import { IntlProps, TrackedLink } from '../common';

const useStyles = makeStyles({
    description: {
        paddingTop: tokens.spacingVerticalXS,
        maxHeight: '2rem',
        color: tokens.colorNeutralForeground4,
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase200,
        overflowX: 'hidden',
        overflowY: 'hidden',
    },
});

// Curriculum title data grid cell properties.
export type TitleCellProps = Readonly<{
    title: string;
    titleLinkUrl?: string;
    description?: string;
}>;

// Curriculum title data grid cell layout.
export const TitleCell: FC<TitleCellProps> = injectIntl((props: IntlProps<TitleCellProps>) => {
    const { title, titleLinkUrl, description } = props;
    const styles = useStyles();

    return (
        <TableCellLayout>
            {titleLinkUrl !== undefined && (
                <TrackedLink trackAction="open" href={titleLinkUrl}>
                    {title}
                </TrackedLink>
            )}
            {titleLinkUrl === undefined && title}
            <div className={styles.description}>{description}</div>
        </TableCellLayout>
    );
});

export default TitleCell;
